import React, { ReactNode } from 'react';

import { VirtualAssistantProvider } from './context/VirtualAssistantProvider';

interface VirtualAssistantAppProps {
  children: ReactNode;
}

export function VirtualAssistantApp({ children }: VirtualAssistantAppProps) {
  return <VirtualAssistantProvider>{children}</VirtualAssistantProvider>;
}
